<template>
    <DefaultHeader :noMargin="true" />

    <div :class="{ 'd-none': this.$store.state.hiddenBody }" class="container mt-4">
        <div class="card shadow bg-white">
            <div class="card-header h6 d-flex justify-content-between align-items-center">
                <span>Configuration des alarmes</span>

                <router-link class="btn btn-outline-secondary btn-sm" :to="'/balise/' + baliseId">
                    Retour
                </router-link>
            </div>

            <div class="card-body">
                <div v-if="isLoading" class="text-center text-muted py-4">
                    Chargement...
                </div>

                <div v-else>
                    <div class="alert alert-light small">
                        <strong>Fallback legacy :</strong>
                        la valeur "Défaut" signifie qu'aucune surcharge n'est appliquée pour ce champ.
                    </div>

                    <div v-if="configs.length === 0" class="text-center text-muted py-4">
                        Aucun type d'alarme trouvé.
                    </div>

                    <div v-else class="table-responsive">
                        <table class="table table-sm align-middle">
                            <thead>
                                <tr>
                                    <th>Alarme</th>
                                    <th class="text-center">Télésurveillance</th>
                                    <th class="text-center">Sauvegarde BDD</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="config in configs" :key="config.alarmTypeId">
                                    <td>
                                        <div class="fw-semibold">
                                            {{ getAlarmTypeName(config) }}
                                        </div>
                                        <div class="small text-muted">
                                            ID {{ config.alarmTypeId }}
                                        </div>
                                    </td>

                                    <td class="text-center">
                                        <select
                                            class="form-select form-select-sm"
                                            :class="getSelectClass(config.shouldSendToRemoteMonitoring)"
                                            v-model="config.shouldSendToRemoteMonitoring"
                                        >
                                            <option :value="null">Défaut</option>
                                            <option :value="true">Oui</option>
                                            <option :value="false">Non</option>
                                        </select>
                                    </td>

                                    <td class="text-center">
                                        <select
                                            class="form-select form-select-sm"
                                            :class="getSelectClass(config.shouldSaveDb)"
                                            v-model="config.shouldSaveDb"
                                        >
                                            <option :value="null">Défaut</option>
                                            <option :value="true">Oui</option>
                                            <option :value="false">Non</option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="d-flex justify-content-end mt-3">
                        <button
                            class="btn btn-primary"
                            :disabled="isSaving"
                            @click="saveConfigs"
                        >
                            <font-awesome-icon v-if="isSaving" :icon="['fas', 'spinner']" spin />
                            <font-awesome-icon v-else :icon="['fas', 'floppy-disk']" />
                            Enregistrer
                        </button>
                    </div>

                    <div v-if="successMessage" class="alert alert-success mt-3 mb-0">
                        {{ successMessage }}
                    </div>

                    <div v-if="errorMessage" class="alert alert-danger mt-3 mb-0">
                        {{ errorMessage }}
                    </div>
                </div>
            </div>

            <div class="card-footer p-3 text-center text-muted">
                Uniquement visible aux admin Argos
            </div>
        </div>
    </div>

    <DefaultFooter class="mt-4" />
</template>

<script>
import DefaultHeader from '@/components/DefaultHeader.vue'
import DefaultFooter from '@/components/DefaultFooter.vue'
import BaliseService from '@/services/balise.service.js'

export default {
    components: {
        DefaultHeader,
        DefaultFooter
    },
    data() {
        return {
            baliseId: this.$route.params.id,
            configs: [],
            isLoading: true,
            isSaving: false,
            successMessage: null,
            errorMessage: null
        };
    },
    mounted() {
        this.refreshData();
    },
    methods: {
        refreshData() {
            this.isLoading = true;
            this.successMessage = null;
            this.errorMessage = null;

            BaliseService.getAlarmTypeConfigs(this.baliseId)
                .then(response => {
                    this.configs = Array.isArray(response.data)
                        ? response.data.map(config => ({
                            alarmTypeId: config.alarmTypeId,
                            alarmType: config.alarmType,
                            shouldSendToRemoteMonitoring: config.shouldSendToRemoteMonitoring,
                            shouldSaveDb: config.shouldSaveDb
                        }))
                        : [];
                })
                .catch(error => {
                    console.log(error);
                    this.errorMessage = "Impossible de charger la configuration des alarmes.";
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        saveConfigs() {
            this.isSaving = true;
            this.successMessage = null;
            this.errorMessage = null;

            const configs = this.configs.map(config => ({
                alarmTypeId: config.alarmTypeId,
                shouldSendToRemoteMonitoring: config.shouldSendToRemoteMonitoring,
                shouldSaveDb: config.shouldSaveDb
            }));

            BaliseService.updateAlarmTypeConfigs(this.baliseId, configs)
                .then(() => {
                    this.successMessage = "Configuration enregistrée avec succès.";
                    this.refreshData();
                })
                .catch(error => {
                    console.log(error);
                    this.errorMessage = "Impossible d'enregistrer la configuration.";
                })
                .finally(() => {
                    this.isSaving = false;
                });
        },
        getAlarmTypeName(config) {
            return config.alarmType?.name
                || config.alarmType?.label
                || config.alarmType?.code
                || 'Alarme inconnue';
        },
        getSelectClass(value) {
            if (value === true) return 'select-yes';
            if (value === false) return 'select-no';
            return '';
        }
    }
}
</script>

<style scoped>
.select-yes {
    background-color: #d1f7d6;
    border-color: #8ed89b;
}

.select-no {
    background-color: #f8d7da;
    border-color: #e5a5ad;
}
</style>